<div
  class="container-box"
  [class.no-padding]="padding === 'none'"
  [style.margin-bottom]="margin === 'none' ? 0 : '2rem'"
  [@fadeInUp]
  [class.skyblue]="background === 'SKYBLUE'"
>
  <ng-content></ng-content>
</div>
